import { HStack, Tag, TagLabel } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DEFAULT_HARDCODED_TAGS, POPULAR_SEARCH_TAGS } from './GifsWidgetPack.config';

interface SuggestedTagListProps {
  onTagClick: (value: string, shouldSetQueryStr?: boolean) => void;
}

const StyledTagList = styled(HStack)`
  ::-webkit-scrollbar {
    height: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: var(--vg-colors-gray-200);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  padding-inline-start: 0;
`;

export const SuggestedTagList = memo(({ onTagClick: onTagSearch }: SuggestedTagListProps) => {
  const tags = useMemo(() => [...POPULAR_SEARCH_TAGS, ...DEFAULT_HARDCODED_TAGS], []);
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.gifsMenu.tags' });

  const onTagClick = (value: string) => () => {
    onTagSearch(value);
  };

  return (
    <StyledTagList overflowX={'auto'} spacing={2} paddingX={4} minHeight={12} data-testid='suggested-gifs-tags'>
      {tags.slice(0, 4).map((tag, index) => {
        return (
          <Tag
            key={index}
            as={'button'}
            size={'sm'}
            variant={'suggested-tag'}
            onClick={onTagClick(tag)}
            pointerEvents={'auto'}
            width={'100%'}
            justifyContent={'center'}
          >
            <TagLabel>{t(tag as keyof typeof t)}</TagLabel>
          </Tag>
        );
      })}
    </StyledTagList>
  );
});
SuggestedTagList.displayName = 'SuggestedTagList';
